import React, { createContext, useContext, useState } from 'react';

const FinContext = createContext();

export const useFIN = () => useContext(FinContext);

export const FINProvider = ({ children }) => {
    const [branch, setBranch] = useState(1);
    const [displayBook, setDisplayBook] = useState(1);
    const [currency, setCurrency] = useState(1);
    const [setup, setSetup] = useState(localStorage.getItem('setup') || '01-01-2025');

    return (
        <FinContext.Provider value={{ branch, setBranch, displayBook, setDisplayBook, currency, setCurrency, setup, setSetup }}>
            {children}
        </FinContext.Provider>
    );
};
